import { useEffect, useState } from "react";
import FilterBar from "./FilterBar";
import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Tooltip,
  Cell,
  Legend
} from "recharts";
import api from "../../../../services/api";

function TipoPieChart() {
  const [dados, setDados] = useState([]);
  const [filtro, setFiltro] = useState({});

  // Paleta padrão do dashboard
  const cores = ["#2f80ed", "#17a2b8"];

  async function carregar(params = {}) {
    try {
      const res = await api.get("/v1/dashboard/tipo", {
        params: {
          dt1: params.inicio || "",
          dt2: params.fim || "",
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      });

      const r = res.data || {};

      const arr = [
        { nome: "Renovação", quantidade: r.qtderenovacao || 0 },
        { nome: "Novas", quantidade: r.qtdenovo || 0 }
      ];

      setDados(arr);

    } catch (err) {
      console.error("Erro tipo:", err);
      setDados([]);
    }
  }

  // TOTAL para cálculo de %
  const total = dados.reduce((s, v) => s + v.quantidade, 0);

  // Label externo melhorado
  const renderLabel = ({
    cx, cy, midAngle, innerRadius, outerRadius, payload
  }) => {
    const RAD = Math.PI / 180;
    const radius = outerRadius + 18; // distância do label
    const x = cx + radius * Math.cos(-midAngle * RAD);
    const y = cy + radius * Math.sin(-midAngle * RAD);

    const nome = payload.nome;
    const qtd = payload.quantidade;
    const pct = total === 0 ? 0 : ((qtd / total) * 100).toFixed(0);

    return (
      <text
        x={x}
        y={y}
        fill="#333"
        textAnchor={x > cx ? "start" : "end"}
        dominantBaseline="central"
        style={{ fontSize: 13, fontWeight: 600 }}
      >
        {`${nome}: ${qtd} (${pct}%)`}
      </text>
    );
  };

  return (
    <div className="dashboard-card">

      {/* HEADER */}
      <div className="header-row">
        <div className="dashboard-header">
          <i className="fa fa-chart-pie"></i> Tipos de Fichas
        </div>
        <button
          className="btn btn-sm btn-outline-primary btn-refresh"
          onClick={() => carregar(filtro)}
        >
          <i className="fa fa-sync"></i>
        </button>
      </div>

      <div className="dashboard-body">
        {/* FILTRO */}
        <FilterBar
          onChange={(f) => {
            setFiltro(f);
            carregar(f);
          }}
        />

        {/* GRÁFICO */}
        <div className="chart-area" style={{ width: "100%", height: "260px" }}>
          {dados.length === 0 ? (
            <div>Sem dados</div>
          ) : (
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>

                <Pie
                  data={dados}
                  dataKey="quantidade"
                  nameKey="nome"
                  innerRadius={45}
                  outerRadius={70} // donut ajustado
                  paddingAngle={3}
                  labelLine={true}
                  label={renderLabel}
                  animationDuration={900}
                  animationEasing="ease-out"
                >
                  {dados.map((entry, index) => (
                    <Cell key={index} fill={cores[index % cores.length]} />
                  ))}
                </Pie>

                <Tooltip
                  contentStyle={{
                    fontSize: "14px",
                    borderRadius: "8px"
                  }}
                />

                {/* LEGENDA EMBAIXO — fica mais equilibrado */}
                <Legend
                  layout="horizontal"
                  verticalAlign="bottom"
                  align="center"
                  iconSize={12}
                  wrapperStyle={{
                    fontSize: "13px",
                    marginTop: "10px"
                  }}
                />
              </PieChart>
            </ResponsiveContainer>
          )}
        </div>
      </div>
    </div>
  );
}

export default TipoPieChart;
